import { PixelCrop } from 'react-image-crop';
import { canvasPreview } from './canvas-preview';

let previewUrl = ''

function toBlob(canvas: HTMLCanvasElement): Promise<Blob> {
  return new Promise((resolve) => {
    canvas.toBlob(resolve as any)
  })
}

// Returns an image source you should set to state and pass
// `{previewSrc && <img alt="Crop preview" src={previewSrc} />}`
export async function createImagePreview(
  image: HTMLImageElement,
  crop: PixelCrop,
  scale = 1,
  rotate = 0,
) {
  const canvas = document.createElement('canvas')
  canvasPreview(image, canvas, crop, scale, rotate)

  const blob = await toBlob(canvas)
  clearImagePreview();

  previewUrl = URL.createObjectURL(blob)
  return previewUrl
}

export function clearImagePreview() {
  if (previewUrl) {
    URL.revokeObjectURL(previewUrl)
  }
}